import { render } from "./FooterComponent.vue?vue&type=template&id=25ad752c&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "@/styles/footer.scss?vue&type=style&index=0&lang=scss&external"
import "./FooterComponent.vue?vue&type=style&index=1&id=25ad752c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ad752c"]])

export default __exports__